/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material';
import { environment } from '../../../../src/environments/environment';
import { IceTypes } from '../models/icetypes';

declare var require: any;

export class Iceutility {
  static MinValue_DotNet_Ticks: number = 3155378975999999999;
  static Jan1970_DotNet_Ticks: number = 621355968000000000;
  static daylightSavings: boolean = Iceutility.isDaylightSaving(new Date());

  static getCurrentDateFormat(): string {
    let dft = sessionStorage.getItem("g_currentdateformat");
    return dft == null || dft.length == 0 ? this.getDateFormat(IceTypes.DATE_FORMATS.mm_dd_yyyy) : dft;
  }

  static setLocal(dtAdaptor: DateAdapter<Date>, defDateFormat: string, override: boolean = false) {
    if (dtAdaptor == null) return;

    let curAct = sessionStorage.getItem("g_currentact");
    if (curAct == null || curAct.length == 0) {
      let setThisLocal = !Iceutility.isStringUndefinedNullOrEmpty(defDateFormat) && defDateFormat == "MM/dd/yyyy" ? IceTypes.LanguageMap.US.locale : IceTypes.LanguageMap.GB.locale;
      dtAdaptor.setLocale(setThisLocal);
    }
    else {
      let curDateFmt = !override ? Iceutility.getCurrentDateFormat() : defDateFormat;
      if (curDateFmt == null || curDateFmt.length == 0) {
        curDateFmt = defDateFormat;
      }
      let setThisLocal = !Iceutility.isStringUndefinedNullOrEmpty(curDateFmt) && curDateFmt == "MM/dd/yyyy" ? IceTypes.LanguageMap.US.locale : IceTypes.LanguageMap.GB.locale;
      dtAdaptor.setLocale(setThisLocal);
    }
  }

  static isDaylightSaving(date: any): boolean {
    const january = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
    const july = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
    if (january == july) return true; // DLS does not apply
    return Math.max(january, july) !== date.getTimezoneOffset();
  }

  static ConvertFromDotNetServerTime(tick: string, doOffset?: boolean): Date {
    try {
      if (Iceutility.isdefined(tick) == false) return new Date();
      var datecheck = parseFloat(tick);
      if (isNaN(datecheck)) return new Date(tick);
      if (doOffset == null) doOffset = true;

      let jsActivitDateTicks = datecheck - Iceutility.Jan1970_DotNet_Ticks;
      let acttime = jsActivitDateTicks / 10000;
      var servoffset = 180;
      var servoffsetDayLST = this.daylightSavings ? 60 : 0;
      var actdate = new Date(acttime);
      if (doOffset == true) {
        var offsetMin = (servoffset + servoffsetDayLST);
        actdate = new Date(acttime + offsetMin * 60 * 1000);
      }
      return actdate;
    }
    catch (e) {
      console.log("Error in ConvertFromDotNetServerTime.");
    }
    return null;
  }

  // Deprecated as of August 5, 2021, please use getDateTextEx(...) instead
  static ConvertStringToLocal(dtText: string) {
    if (Iceutility.isdefined(dtText) == false || dtText.constructor.name != "String")
      return "";

    if (dtText.trim() == "")
      return "";

    try {
      // checking if the date has timestamp
      if (dtText.split(" ").length == 1) { // timestamp not present. append current timestamp.
        var timestring = new Date().toTimeString().split(" ");
        dtText = dtText + " " + timestring[0];
      }

      if (dtText.indexOf("Z") == -1)
        dtText = dtText + " Z"; // appending "Z" to convert to local time

      dtText = new Date(dtText).toString();
      return Iceutility.GetDateText(dtText);
    } catch (e) {
      console.log(e.message);
    }
  }

  // Deprecated as of August 5, 2021, please use convertToUTCEx(...) instead.
  static ConvertStringToUTC(dtText: string) {
    if (Iceutility.isdefined(dtText) == false || dtText.constructor.name != "String")
      return "";

    if (dtText.trim() == "")
      return "";

    try {
      // checking if the date has timestamp
      // if not, append the timestamp in order to succssfully convert it to UTC.
      if (dtText.split(" ").length == 1) { // timestamp not present. append current timestamp.
        var timestring = new Date().toTimeString().split(" ");
        dtText = dtText + " " + timestring[0] + " " + timestring[1];
      }

      var utc_dt = new Date(dtText);
      var offset = utc_dt.getTimezoneOffset();
      utc_dt.setMinutes(utc_dt.getMinutes() + offset);
      return Iceutility.GetDateText(utc_dt);
    } catch (e) {
      console.log(e.message);
    }
  }

  // Deprecated as of August 5, 2021, please use getDateTextEx(...) instead
  static ConvertToLocal(dt: any, includeTimestamp: boolean = true, includeDate: boolean = true) {
    if (Iceutility.isdefined(dt) == false) {
      return "";
    }

    var temp_dt = "";

    try {
      if (dt.constructor.name == "Date") {
        temp_dt = Iceutility.GetDateText(new Date(dt));
      } else if (dt.constructor.name == "String") {
        temp_dt = Iceutility.ConvertStringToLocal(dt);
      }

      if (includeTimestamp == false) {
        temp_dt = temp_dt.split(" ")[0];
      }

      if (includeDate == false) {
        temp_dt = temp_dt.split(" ")[1] + " " + temp_dt.split(" ")[2];
      }
    } catch (e) {
      console.log(e.message);
    }

    return temp_dt;
  }

  static ConvertToUTC(dt: any, includeTimestamp: boolean) {
    if (Iceutility.isdefined(dt) == false)
      return false;

    if (Iceutility.isdefined(includeTimestamp) == false)
      includeTimestamp = true;

    var temp_dt = "";

    if (dt.constructor.name == "String") {
      temp_dt = new Date(dt).toISOString();
    } else if (dt.constructor.name == "Date") {
      temp_dt = dt.toISOString();
    }

    return temp_dt;
  }

  static convertToUTCEx(dt: any): string {
    if (this.isdefined(dt) == false) return "";

    let temp_dt = "";

    try {
      if (dt.constructor.name == "String") {
        if (this.getCurrentDateFormat() == this.getDateFormat(IceTypes.DATE_FORMATS.mm_dd_yyyy)) {
          temp_dt = new Date(dt).toISOString();
        }
        else if (this.getCurrentDateFormat() == this.getDateFormat(IceTypes.DATE_FORMATS.dd_mm_yyyy)) {
          let temp_time = "";
          let fulldtparts = dt.split(" ");
          if (fulldtparts.length > 0)
            temp_dt = fulldtparts[0];

          if (fulldtparts.length > 1)
            temp_time = " " + fulldtparts[1];

          if (fulldtparts.length > 2)
            temp_time += " " + fulldtparts[2];

          let dtparts = temp_dt.split("/");
          if (dtparts.length == 3) {
            temp_dt = this.buildDefaultDateString("", dtparts[1], dtparts[0], dtparts[2], "", temp_time);
            temp_dt = this.GetLocalDate(temp_dt).toISOString();
          }
          else {
            throw "Error: invalid date";
          }
        }
      } else if (dt.constructor.name == "Date") {
        temp_dt = dt.toISOString();
      }
    } catch (e) {
      console.log(e.message);
    }

    return temp_dt;
  }

  static buildDefaultDateString(format, month, day, year, separator, time): string {
    if (!this.isdefined(format) || format == "") format = this.getDateFormat(IceTypes.DATE_FORMATS.mm_dd_yyyy);
    if (!this.isdefined(month)) return "";
    if (!this.isdefined(day)) return "";
    if (!this.isdefined(year)) return "";
    if (!this.isdefined(separator) || separator == "") separator = "/";
    if (!this.isdefined(time)) time = "";

    switch (format) {
      case this.getDateFormat(IceTypes.DATE_FORMATS.mm_dd_yyyy): {
        return month + separator + day + separator + year + time;
      }
      case this.getDateFormat(IceTypes.DATE_FORMATS.dd_mm_yyyy): {
        return day + separator + month + separator + year + time;
      }
      case this.getDateFormat(IceTypes.DATE_FORMATS.yyyy_mm_dd): {
        return year + separator + month + separator + day + time;
      }
    }
    return month + separator + day + separator + year + time;
  }

  static existinarray(ary, text): boolean {
    if (ary == null) return false;
    if (text == null || text.length == 0) return false;

    let ret: boolean = false;
    for (let j = 0; j < ary.length; j++) {
      var name = ary[j];
      if (name != null && name.length > 0 && Iceutility.stringcomparenocase(name, text)) {
        ret = true;
        break;
      }
    }
    return ret;
  }

  static getCurrentEnvironment() {
    let currentEnv: any = require("../../../../env.json").currentEnv;
    let envs: any = require("../../../../env.json").environments;
    return this.isdefined(envs) ? envs[currentEnv] : {};
  }

  static GetDateText(dt, separator?, includetime?) {
    // Use getcurrentdate(...) // check IsUTC then either use ConvertToLocal or ConvertStringToLocal
    if (Iceutility.isdefined(dt) == false)
      return "";

    if (dt == "Invalid Date")
      return "";

    var newDate = null;

    try {
      newDate = new Date(dt);
      if (newDate == "Invalid Date")
        return "";
      var sMonth = ((newDate.getMonth() + 1) < 10) ? "0" + (newDate.getMonth() + 1) : (newDate.getMonth() + 1);
      var sDay = (newDate.getDate() < 10) ? "0" + newDate.getDate() : newDate.getDate();
      var sYear = newDate.getFullYear();
      var sHour = newDate.getHours();
      var sMinute = (newDate.getMinutes() < 10) ? "0" + newDate.getMinutes() : newDate.getMinutes();
      var period = "AM";
      var iHourCheck = parseInt(sHour);

      if (iHourCheck === 12) {
        period = "PM";
      }
      else if (iHourCheck > 12) {
        period = "PM";
        sHour = iHourCheck - 12;
      }
      else if (iHourCheck === 0) {
        sHour = "12";
      }

      sHour = (sHour < 10) ? "0" + sHour : sHour;
      if (separator == null || separator.length == 0)
        return sMonth + "/" + sDay + "/" + sYear + (includetime == false ? "" : (" " + sHour + ":" + sMinute + " " + period));

      return sMonth + separator + sDay + separator + sYear + (includetime == false ? "" : (" " + sHour + ":" + sMinute + " " + period));
    } catch (e) {
      console.log(e.message);
    }
  }

  static getDateTextEx(dt, separator?: string, includetime?: boolean): string {
    if (this.isdefined(dt) == false || dt.length == 0) return "";
    if (dt == "Invalid Date") return "";
    if (dt === NaN || dt.toString() == "NaN") return "";

    var newDate = null;

    try {
      newDate = new Date(dt);
      if (newDate == "Invalid Date")
        return "";
      var sMonth = ((newDate.getMonth() + 1) < 10) ? "0" + (newDate.getMonth() + 1) : (newDate.getMonth() + 1);
      var sDay = (newDate.getDate() < 10) ? "0" + newDate.getDate() : newDate.getDate();
      var sYear = newDate.getFullYear();
      var sHour = newDate.getHours();
      var sMinute = (newDate.getMinutes() < 10) ? "0" + newDate.getMinutes() : newDate.getMinutes();
      var period = "AM";
      var iHourCheck = parseInt(sHour);

      if (iHourCheck === 12) {
        period = "PM";
      }
      else if (iHourCheck > 12) {
        period = "PM";
        sHour = iHourCheck - 12;
      }
      else if (iHourCheck === 0) {
        sHour = "12";
      }

      sHour = (sHour < 10) ? "0" + sHour : sHour;
      if (separator == null || separator.length == 0)
        separator = "/";

      return this.buildDefaultDateString(this.getCurrentDateFormat(), sMonth, sDay, sYear, separator, (includetime == false ? "" : (" " + sHour + ":" + sMinute + " " + period)));
    } catch (e) {
      console.log(e.message);
    }
  }

  static GetLocalDate(dt?: string): Date {
    try {
      if (Iceutility.isdefined(dt) == false || dt.trim() == "")
        return new Date();

      return new Date(dt);
    } catch (e) {
      console.log(e.message);
    }
  }

  static convertDatesToWeeks(dtFrom: any, dtTo: any): number {
    if (!this.isdefined(dtFrom) || dtFrom.constructor.name != "Date") return 0;
    if (!this.isdefined(dtTo) || dtTo.constructor.name != "Date") return 0;

    return (dtTo - dtFrom) / (7 * 24 * 60 * 60 * 1000);
  }

  static convertDatesToYears(dtFrom: any, dtTo: any): number {
    if (!this.isdefined(dtFrom) || dtFrom.constructor.name != "Date") return 0;
    if (!this.isdefined(dtTo) || dtTo.constructor.name != "Date") return 0;

    return (dtTo - dtFrom) / (24 * 3600 * 365.25 * 1000);
  }

  static getObjectFromArray(array: any[], key: string, value: string) {
    let filteredObj = {};

    if (this.isdefined(array)) {
      filteredObj = array.find(item => item[key] === value);
    }

    return filteredObj;
  }

  static getObjectIndexFromArray(array: any[], key: string, value: string) {
    let index = -1;

    if (this.isdefined(array)) {
      index = array.findIndex(item => item[key] === value);
    }

    return index;
  }

  static getYear(): number {
    return this.GetLocalDate().getFullYear();
  }

  static guid(nohyphen: boolean = false): string {
    function _p8(s) {
      let p = (Math.random().toString(16) + "000000000").substr(2, 8);
      if (false == nohyphen)
        return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
      else {
        s = s ? p.substr(0, 4) + p.substr(4, 4) : p;
        return s.toUpperCase();
      }
    }
    return _p8(false) + _p8(true) + _p8(true) + _p8(false);
  }

  static isdefined(thisvariable: any): boolean {
    if (typeof thisvariable != 'undefined' && thisvariable != null) {
      return true;
    }
    return false;
  }

  static isfunction(thisfunction: any): boolean {
    if (typeof thisfunction == 'function') {
      return true;
    }
    return false;
  }

  static isMobileDevice() {
    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i))
      return true;

    return window.innerWidth < 768;
  }

  static isobject(thisvariable: any): boolean {
    if (typeof thisvariable == 'object')
      return true;


    return false;
  }

  static isstring(thisvariable: any): boolean {
    if (typeof thisvariable == 'string')
      return true;


    return false;
  }

  static isStringUndefinedNullOrEmpty(value) {
    return !Iceutility.isdefined(value) || value === "";
  }

  static IsUTC(dt) {
    // check for text if text then parse otherwise use js check flag
    if (Iceutility.isdefined(dt) == false)
      return false;

    var isUtc = false;

    try {
      if (dt.constructor.name == "String") {
        // todo: change the logic
        if (dt.indexOf("GMT") >= 0 || dt.indexOf("0000") >= 0) {
          isUtc = true;
        }
      } else if (dt.constructor.name == "Date") {
        var timezoneOffset = new Date().getTimezoneOffset();

        if (timezoneOffset == 0) {
          isUtc = true;
        }
      }

    } catch (e) {
      console.log(e.message);
    }

    return isUtc;
  }

  static isTextDateTime(txt: string): boolean {
    if (this.isdefined(txt) == false)
      return false;

    if (typeof txt !== 'string' || txt.length == 0) return false;

    let istxtDt = false;

    try {
      istxtDt = txt.indexOf("/") > 0 || txt.indexOf("-") > 0 || txt.indexOf(":") > 0;
    } catch (e) {
      console.log(e.message);
    }

    return istxtDt;
  }

  static isDate(val: any) {
    return val instanceof Date;
  }

  static Now(utcflag = false, includeTimestamp = true) {
    var dt = "";

    try {
      if (utcflag) {
        var local_dt = new Date();
        var offset = local_dt.getTimezoneOffset();
        local_dt.setMinutes(local_dt.getMinutes() + offset);
        dt = Iceutility.GetDateText(local_dt);
      } else {
        var dt_local = new Date(Date.now());
        dt = Iceutility.GetDateText(dt_local);
      }

      if (includeTimestamp == false)
        dt = dt.split(" ")[0];
    } catch (e) {
      console.log(e.message);
    }

    return dt;
  }

  static addTime(dt: Date, days: number, hours: number, minutes: number, seconds: number) {
    if (!Iceutility.isdefined(dt) || dt.constructor.name != "Date") return dt;
    let secUnits = 1000;
    let minUnits = secUnits * 60;
    let hourUnits = minUnits * 60;
    let daysUnits = hourUnits * 24;

    let totalTicks = 0;
    if (Iceutility.isdefined(days) && typeof days === "number") totalTicks += (daysUnits * days);
    if (Iceutility.isdefined(hours) && typeof hours === "number") totalTicks += (hourUnits * hours);
    if (Iceutility.isdefined(minutes) && typeof minutes === "number") totalTicks += (minUnits * minutes);
    if (Iceutility.isdefined(seconds) && typeof seconds === "number") totalTicks += (secUnits * seconds);

    dt.setTime(dt.getTime() + totalTicks);
    return dt;
  }

  static getDateFormat(dtfmt: IceTypes.DATE_FORMATS) {
    switch (dtfmt) {
      case IceTypes.DATE_FORMATS.mm_dd_yyyy: {
        return "MM/dd/yyyy";
      }
      case IceTypes.DATE_FORMATS.dd_mm_yyyy: {
        return "dd/MM/yyyy";
      }
      case IceTypes.DATE_FORMATS.yyyy_mm_dd: {
        return "yyyy/MM/dd";
      }
    }
    return "dd/MM/yyyy";
  }

  static prepareFromToDates(fromdate, todate, includeTimestamp) {
    if (includeTimestamp) {
      fromdate += " 00:00:00 AM";
      todate += " 11:59:59 PM";
    }

    return {
      from: Iceutility.ConvertToUTC(fromdate, true),
      to: Iceutility.ConvertToUTC(todate, true)
    };
  }

  static searchArrayByField(items: any[], field: string, value: any) {
    if (items == null || items.length == 0)
      return -1;

    if (field == null || field.length == 0)
      return -1;

    let itemIndex: number = -1;
    try {
      for (let index = 0; index < items.length; index++) {
        let obj = items[index];

        if (obj[field] === value) {
          itemIndex = index;
          break;
        }
      }
    } catch (e) {
      console.log(e);
    }
    return itemIndex;
  }

  static stringCapitalize(value) {
    if (typeof value !== 'string') return ''
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  static stringcomparenocase(text1, text2): boolean {
    if ((text1 == null || text1.length == 0)
      && (text2 == null || text2.length == 0)) {
      return true;
    }

    var ret = false;
    var regex = null;
    try {
      if (text1 == null)
        text1 = "";

      regex = new RegExp('^' + text1 + '$', 'i');

      if (regex.test(text2)) {
        ret = true;
      }
    }
    catch (Error) {
    }
    regex = null;
    return ret;
  }

  static toLong(val: any): number {
    if (false == this.isdefined(val))
      return 0;

    if (val == null || "" == val || "NaN" == val.toString())
      return 0;

    if (typeof val == "number") return val;

    return parseInt(val, 10);
  }

  static toDouble(val: any): number {
    if (false == this.isdefined(val))
      return 0;

    if (val == null || "" == val || "NaN" == val.toString())
      return 0;

    if (typeof val == "number") return val;

    return parseFloat(val);
  }

  static toBoolean(val: any): boolean {
    if (false == this.isdefined(val))
      return false;

    if (val == null || val.length == 0 || "NaN" == val.toString())
      return false;

    if (typeof val == "string") {
      let thisval = val.toLowerCase();
      if (thisval == "true" || thisval == "1")
        return true;
    } else {
      if (val == true || val == 1)
        return true;
    }
    return false;
  }

  static toCurrency(val: any, curr: string = 'USD'): string {
    if (curr == null || curr.length == 0) curr = 'USD';
    return Iceutility.toDouble(val).toLocaleString('en-US', {
      style: 'currency',
      currency: curr,
    });
  }

  static abbreviate(text: string): string {
    if (text == null || text.length == 0) return "";

    let ret = "";
    var split_names = text.trim().split(" ");
    for (let i = 0; i < split_names.length; i++) {
      ret += split_names[i].charAt(0)
    }
    return ret;
  }

  static isValidEmail(email: string): boolean {
    let expression = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return expression.test(email.toLowerCase());
  }

  static renderRightArrow(): string {
    return '&nbsp;<i class="fas fa-arrow-right"></i>&nbsp;';
  }

  static scrollToTop(): void {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    })
  }

  static scrollToBotton(): void {
    window.scroll({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  }

  static contains(value, valToCompare): boolean {
    return value.toString().indexOf(valToCompare.toString()) >= 0;
  }

  static yesnomodal(msg: string): boolean {
    return confirm(msg);
  }

  static formatUrl(router) {
    if (!router) return "";

      var url = router.url;
      if (url.indexOf("#") >= 0) {
        return url.split("#")[0];
      }

      return url;
  }
  
  static formatXml(xmlString: string): string {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "application/xml");

    const serializer = new XMLSerializer();
    const formattedXml = serializer.serializeToString(xmlDoc);
    return formattedXml;
  }

  static formatXmlIndent(xmlString: string, indent: string = '  '): string {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "application/xml");

    let result = '';
    let level = 0;

    let processNode: Function = (node) => {
      let indentation = indent.repeat(level);
      if (node.nodeType === Node.ELEMENT_NODE) {
        result += `${indentation}<${node.tagName}`;
        for (let i = 0; i < node.attributes.length; i++) {
          const attr = node.attributes[i];
          result += ` ${attr.name}="${attr.value}"`;
        }
        if (node.childNodes.length > 0) {
          result += '>\n';
          level++;
          for (let i = 0; i < node.childNodes.length; i++) {
            processNode(node.childNodes[i]);
          }
          level--;
          result += `${indentation}</${node.tagName}>\n`;
        } else {
          result += '/>\n';
        }
      } else if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '') {
        result += `${indentation}${node.nodeValue.trim()}\n`;
      }
    }

    processNode(xmlDoc.documentElement);
    return result;
  }
}
